import { render, staticRenderFns } from "./LoginFlowStepOTPUnavailable.vue?vue&type=template&id=01f9703a&"
import script from "./LoginFlowStepOTPUnavailable.vue?vue&type=script&lang=ts&"
export * from "./LoginFlowStepOTPUnavailable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports